<!-- æ”¶ä¹¦ä¸€è§ˆ -->
<template>
  <div id="bookRoom">
      <iframe src="http://192.168.0.33/spring/front/read?lid=t3004&isresearchroom=yes" id="qt" scrolling="no" frameborder="e" >
      </iframe>
  </div>
</template>

<script>
export default {
  data () { 
    return {

    }
  },
  methods: {
    changeqtIframe () {

    }
  },
  // ç”Ÿå‘½å‘¨æœŸ - åˆ›å»ºå®Œæˆ�ï¼ˆè®¿é—®å½“å‰�thiså®žä¾‹ï¼‰
  created () {

  },
  // ç”Ÿå‘½å‘¨æœŸ - æŒ‚è½½å®Œæˆ�ï¼ˆè®¿é—®DOMå…ƒç´ ï¼‰
  mounted () {
     // eslint-disable-next-line no-unused-vars
     function changeqtIframe () {
        // const qt = document.getElementById('qt')
        // const devicewidth = document.body.clientwidth
        // const deviceHeight = document.body .clientHeight
        // qt.style.width = Number(devicewidth) + 'px'  //æ•°å­—æ˜¯é¡µé�¢å¸ƒå±€å®½åº¦å·®å€¼
        // qt.style.height = Number(deviceHeight) + 'px'   //æ•°å­—æ˜¯é¡µé�¢å¸ƒå±€é«˜åº¦å·®
        
     }

     //changeqtIframe()

     window.onresize = function () {
        // changeqtIframe()
     }
  }
}
</script>
<style scoped>
/* @import url(); å¼•å…¥cssç±» */
#bookRoom{
    width: 100%;
    height: calc(100vh - 63px);
    overflow: hidden;
 
}

#qt{
    width: 100%;
    height: 100%;
    
}

</style>
